import gsap from "gsap/gsap-core";
import React,  { useState } from "react";
import { useHistory, useLocation } from "react-router";
import styled from "styled-components";
import { devices } from "../../styles";
import ResetModal from "../ResetModal";
import { dictionary } from "../../contexts/site";


export default function TopButtons({ name, goToIntersection, active, setShowICS, showICS, resetProgress}) {
  const location = useLocation();
  const history = useHistory();
  const isDetails = location.pathname.includes("/details");
  const isExit = location.pathname.includes("/exit");
  const isIntersection = location.pathname.includes("/intersection");
  const isResultsScreen = location.pathname.includes("/results");
  const isFirstPage = location.pathname.includes("/Mary/0");
  const [showResetModal, setShowResetModal] = useState(false);

  const onBack = () => {
    setShowICS(false);

    /* fade in container
*/    const wrapperAnimation = gsap.fromTo(
    ".wrapper",
    { height: 0 },
    {
      height: document.getElementsByClassName("answer-explanation")[0].offsetHeight  + 65,
      duration: 0.5,
    }
  );

  wrapperAnimation.then(() => {});
  }; 
  
  const openModal = () => {
    setShowICS(false);
    setShowResetModal(true);
  };

  const onMouseEnter = (e) => {
    if (e.target.tagName === 'IMG' && location.pathname.includes(`/${name}/7`)) {
        e.target.parentElement.style.minWidth = dictionary.buttons.restartWidth;
    }
  };

  const onMouseLeave = (e) => {
      if (e.target.tagName === 'IMG' && location.pathname.includes(`/${name}/7`)) {
        e.target.parentElement.style.minWidth = '60px';
      }
      if (e.target.tagName === 'DIV' && location.pathname.includes(`/${name}/7`)) {
        e.target.style.minWidth  = '60px';
      }
  };

  return (
    <Wrapper>

      <span style={{"display" : showResetModal ? "none" : "inherit" }}>
        <TopButton  className="topButton" disabled={isDetails || isIntersection || isExit}>
          {!isResultsScreen && (
            <div 
              style={{"minWidth": dictionary.buttons.restartWidth}}
              className={isFirstPage ? "active" : null}
              onClick={openModal}
              onKeyPress={openModal}
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
              >
              <img alt="restart" 
                src="./restart_icon.svg"/>
                <span dangerouslySetInnerHTML={{__html: dictionary.buttons.restart}} />
            </div>
          )}
        </TopButton>

        <BackButton>
          {showICS && 
              <div
                id="back"
                onClick={() => {
                  onBack();
                }}>
                <img
                  id="back-icon"
                  alt="back icon"
                  src="./back.svg"/>
                  <span>{dictionary.buttons.back}</span>
              </div>
          }
        </BackButton>
      </span>
      <ResetModal 
          showResetModal={showResetModal}
          setShowResetModal={setShowResetModal}
          resetProgress={resetProgress}
         />
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  position: absolute;
  top: 10px;
  z-index: 1;
  left: 0px;
  right: 0px;
  display: flex;
  //justify-content: space-between;

  @media ${devices.M} {
    left: -20px;
    //right: -20px;
  }
`;

export const TopButton = styled.div`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "initial")};
  opacity: ${({ disabled }) => (disabled ? "0.2 !important" : 1)};
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #ffffff;
  font-weight: 600;
  position: relative;
  justify-content: center;
  //min-width: 80px;
  //min-height: 80px;

  svg g {
    cursor: pointer;
    width: 80px;
    height: 80px; 
  }

  > div {
    overflow:hidden;
    span {
      text-indent: -99999px;
      display: inline-block;
      padding-left: 5px;
    }
    &.active,
    &:hover {
      background-color: white;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 8px 16px 8px 8px;
      gap: 8px;
      min-width: 100px;
      min-height: 40px;
      background: #FFFFFF;
      border-radius: 20px;
      /* Inside auto layout */
      flex: none;
      order: 3;
      flex-grow: 0;
      margin-left: 18px;
      margin-top: 12px;
      cursor: pointer;
      @media ${devices.M} {
        margin-left: 60px;
      }
      @media ${devices.L} {
        margin-left: 22px;
      }
      img {
        z-index: 10;
      }

      span {
        text-indent: 30px;
        color: #0E3859;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        color: #0E3859;
      }
    }
  }

  img {
    position: absolute;
    left: 18px;
    top: 12px;
    height: 40px;
    width: 40px;
  }

  @media ${devices.M} {
    img {
      left:60px;
    }
  }
  @media ${devices.L} {
    img {
      left: 22px;
    }
  }
  div {
    max-width: 70px;
    max-height: 80px;
    margin-right: 10px;

    svg {
      width: 80px !important;
      height: 80px !important;
    }
  }
`;

export const BackButton = styled.div`
  > div {
    cursor: pointer;
    margin-top: 12px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px 8px 8px;
    gap: 8px;

    //width: 86px;
    height: 40px;
    //min-width: 60px;
    
    background: #FFFFFF;
    border-radius: 20px;

    > span {
      color: #0E3859;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #0E3859;
    }
  }
`;
